// angular
import { Component, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';
// types & utils
import { ContactDialogItem } from '../../shared/contact-dialog-item.type';
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';

@Component({
  selector: 'pwj-contact-item',
  standalone: true,
  imports: [ButtonComponent, TranslateModule, NgClass],
  templateUrl: './contact-item.component.html',
  styleUrl: './contact-item.component.scss',
})
export class ContactItemComponent {
  // inputs
  contactData = input.required<ContactDialogItem>();

  // dependencies
  private readonly _dialogRef = inject(DialogRef);
  private readonly _stateManagementService = inject(StateManagementService);

  constructor() {}

  public actionHandler(action?: string) {
    // open chat box
    if (action === 'openChat') {
      this._stateManagementService.isChatBoxOpen.set(true);
      this._dialogRef.close();
    }
  }
}
